export const permissionOptions = [
  ["employeeTransfers", "Funcionários · solicitar transferência de O.S."],
  ["employeeOnu", "Funcionários · consultar ONUs para ativação"],
  ["employeeOperations", "Funcionários · acompanhar tempos e interromper etapas"],
  ["employeeChat", "Funcionários · conversar com técnicos"],
  ["campaigns", "Campanhas (QR Code e API oficial)"], ["announcements", "Gerenciar informativos"], ["api", "API"],
  ["outages", "Gerenciar indisponibilidade"], ["birthdays", "Configurar aniversários"], ["queues", "Gerenciar filas"],
  ["talkAi", "Talk AI"], ["integrations", "Integrações"],
  ["connections", "Conexões"],
  ["flowbuilder", "Flowbuilder"], ["ai", "Inteligência artificial"],
  ["chatJ10", "Chat J10 (configuração e histórico)"], ["finance", "Financeiro"],
  ["coverageMap", "Mapa de cobertura (somente consulta)"], ["settings", "Configurações"], ["company", "Empresa"]
];
const moduleAliases = {
 connections:["connections","manageConnections"],manageConnections:["connections","manageConnections"],
 chatJ10:["chatJ10","chatJ10History"],chatJ10History:["chatJ10","chatJ10History"]
};
export const hasPermission = (user,key) => user?.profile === "admin" || (moduleAliases[key]||[key]).some(grant=>user?.permissions?.[grant]===true);
export function setModulePermission(permissions,key,enabled) {
 const next={...permissions};
 for(const grant of moduleAliases[key]||[key])next[grant]=enabled===true;
 return next;
}
export function pagePermission(path = "") {
  const p = path.split("?")[0];
  for (const [pattern, key] of [
    [/^\/users(?:\/|$)/, "admin"], [/^\/allConnections(?:\/|$)/, "admin"],
    [/^\/(campaigns|campaigns-config|contact-lists|contact-list-items)(?:\/|$)/, "campaigns"],
    [/^\/announcements(?:\/|$)/, "announcements"], [/^\/messages-api(?:\/|$)/, "api"],
    [/^\/birthday-settings(?:\/|$)/, "birthdays"], [/^\/queues(?:\/|$)/, "queues"],
    [/^\/prompts(?:\/|$)/, "talkAi"], [/^\/queue-integration(?:\/|$)/, "integrations"],
    [/^\/connections(?:\/|$)/, "connections"], [/^\/(flowbuilder[s]?|flowcampaign|phrase-lists)(?:\/|$)/, "flowbuilder"],
    [/^\/coverage-map(?:\/|$)/, "coverageMap"],
    [/^\/ai(?:\/|$)/, "ai"], [/^\/chat-j10(?:\/|$)/, "chatJ10"],
    [/^\/financeiro(?:\/|$)/, "finance"], [/^\/settings(?:\/|$)/, "settings"], [/^\/companies(?:\/|$)/, "company"]
  ]) if (pattern.test(p)) return key;
  return null;
}
export function canAccessPage(user, path) {
  if(/^\/employee-portal-settings(?:\/|$)/.test(path.split("?")[0]))return ["employeeChat","employeeOperations","employeeTransfers","employeeOnu"].some(key=>hasPermission(user,key));
  if(/^\/official-api(?:\/|$)/.test(path.split("?")[0]))return ["connections","campaigns","ai","api"].some(key=>hasPermission(user,key));
  const key = pagePermission(path);
  if (!key) return true;
  if (key === "admin") return user?.profile === "admin";
  if (key === "connections") return hasPermission(user, key) || hasPermission(user, "manageConnections");
  if (key === "chatJ10") return hasPermission(user,key) || hasPermission(user,"chatJ10History");
  return hasPermission(user, key);
}
